<template>
  <div class="main_box">
    <div class="main_bar" v-if="false">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <a href="javascript:void(0)" @click="goBack()"> 投票列表 </a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">投票明细</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <span class="currentSpan">
            {{ voteDetailInfo.VoteName }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <div></div>
    </div>
    <div class="main_body">
      <div class="form_bar">
        <div class="form_bar_search">
          <div class="condition_item">
            <el-radio-group
              v-model="radioView"
              size="small"
              @change="viewChange"
              class="condition_item"
            >
              <el-radio label="user">评委</el-radio>
              <el-radio label="project">待评项</el-radio>
            </el-radio-group>
          </div>
          <div class="condition_item">
            <el-input
              size="mini"
              placeholder="请输入检索项目"
              v-model="projectQuery.KeyWord"
              style="width: 260px"
              v-if="radioView === 'project'"
              clearable
            >
              <el-button
                title="搜索"
                slot="append"
                icon="el-icon-search"
                @click="search()"
              ></el-button>
            </el-input>
            <el-input
              size="mini"
              placeholder="请输入检索投票人"
              v-model="userQuery.KeyWord"
              style="width: 260px; margin: 0px 0px 0px 20px"
              v-if="radioView === 'user'"
              clearable
            >
              <el-button
                title="搜索"
                slot="append"
                icon="el-icon-search"
                @click="search()"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div class="form_bar_btn">
          <el-button type="text" @click="goBack()">返回投票列表</el-button>
          <el-button type="primary" @click="refresh()" size="small" plain>
            刷新
          </el-button>
          <el-button
            type="primary"
            plain
            icon="el-icon-download"
            @click="exportData()"
          >
            导出
          </el-button>
        </div>
      </div>
      <h2 style="text-align: center">
        <div
          v-html="voteInfo.voteName + '（' + voteInfo.voteStrState + '）'"
        ></div>
      </h2>
      <el-table
        border
        :data="voteDetailProjectInfo.Items"
        v-if="radioView === 'project'"
        style="width: 100%"
        :height="tableHeight"
        ref="projectTable"
        :key="projectTableKey"
        :header-cell-class-name="projectTableHeaderCellClassName"
        :cell-class-name="projectTableCellClassName"
        class="vote_detail_el_table--border"
      >
        <!-- <el-table-column label="待评项" width="260" align="right">
          <el-table-column label="投票人" prop="ProjectName" width="260">
          </el-table-column>
        </el-table-column> -->
        <el-table-column
          fixed
          label="待评项"
          min-width="260"
          header-align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.ProjectSort }}
            ）
            {{ scope.row.ProjectName }}
          </template>
        </el-table-column>
        <el-table-column
          min-width="160"
          v-for="(col, index) in voteDetailProjectInfo.Columns"
          :property="col.ColumnProp"
          :key="col.ColumnLabel + index"
        >
          <template slot="header">
            {{ col.Sort }}
            ）
            {{ col.ColumnLabel }}
            <el-link
              type="primary"
              title="移除后的评委不计入有效票数"
              v-if="
                userRole === 1 &&
                !col.IsRemove &&
                voteDetailProjectInfo.Status === 1
              "
              @click="removeVoteUser(col)"
              :key="col.Sort + 'remove'"
            >
              移除
            </el-link>
            <el-link
              type="primary"
              v-if="
                userRole === 1 &&
                col.IsRemove &&
                voteDetailProjectInfo.Status === 1
              "
              @click="addVoteUser(col)"
              :key="col.Sort + 'addUser'"
            >
              添加
            </el-link>
            <el-link
              type="primary"
              title="评委可以重新投票"
              v-if="
                col.IsSubmit &&
                voteDetailProjectInfo.Status === 1 &&
                !voteDetailProjectInfo.IsRealTimeSaveResult
              "
              @click="againVote(col)"
              :key="col.Sort + 'again'"
            >
              重新投票
            </el-link>
            <span
              style="color: #409eff"
              v-if="
                col.IsSubmit &&
                voteDetailProjectInfo.Status === 1 &&
                voteDetailProjectInfo.IsRealTimeSaveResult
              "
            >
              已提交
            </span>
            <span
              style="color: #409eff"
              v-if="col.IsSubmit && voteDetailProjectInfo.Status !== 1"
            >
              已提交
            </span>
            <span style="color: #e6a23c" v-if="!col.IsSubmit"> 未提交 </span>
            <el-link
              type="primary"
              title="全通过提交"
              v-if="
                userRole === 1 &&
                !col.IsSubmit &&
                voteDetailProjectInfo.Status === 1 &&
                voteDetailProjectInfo.VoteType === 0
              "
              @click="submitShortlistedVote(col)"
              :key="col.Sort + 'submitShortlistedVote'"
              style="margin-left: 10px"
            >
              提交
            </el-link>
          </template>
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row[scope.column.property + '_color']
              }"
            >
              {{ scope.row[scope.column.property] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="radioView === 'project'"
        style="margin-top: 10px"
        @size-change="projectHandleSizeChange"
        @current-change="projectHandleCurrentChange"
        :current-page="projectCurrentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500, 1000, 5000]"
        :page-size="projectQuery.MaxResultCount"
        :layout="pagination_layout"
        :total="projectTotalCount"
      >
      </el-pagination>
      <el-table
        border
        :data="voteDetailInfo.Items"
        v-if="radioView === 'user'"
        style="width: 100%"
        :height="tableHeight"
        ref="userTable"
        key="table2"
        :header-cell-class-name="userTableHeaderCellClassName"
        :cell-class-name="userTableCellClassName"
        class="vote_detail_el_table--border"
      >
        <el-table-column fixed label="投票人" width="180" header-align="center">
          <template slot-scope="scope">
            {{ scope.row.Sort }}
            ）
            {{ scope.row.UserName }}
            <el-link
              type="primary"
              title="移除后的评委不计入有效票数"
              v-if="
                userRole === 1 &&
                !scope.row.IsRemove &&
                voteDetailInfo.Status === 1
              "
              @click="removeVoteUser(scope.row)"
              :key="scope.row.UserId + 'remove'"
            >
              移除
            </el-link>
            <el-link
              type="primary"
              v-if="
                userRole === 1 &&
                scope.row.IsRemove &&
                voteDetailInfo.Status === 1
              "
              @click="addVoteUser(scope.row)"
              :key="scope.row.UserId + 'addUser'"
            >
              添加
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          fixed
          label="是否提交"
          width="105"
          header-align="center"
          align="center"
        >
          <template slot-scope="scope">
            <div
              style="
                width: 100%;
                padding: 0px;
                margin: 0px;
                display: -webkit-flex;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
              "
            >
              <span
                style="color: #409eff"
                v-if="scope.row.IsSubmit && voteDetailInfo.Status !== 1"
              >
                已提交
              </span>
              <span
                style="color: #409eff"
                v-if="
                  scope.row.IsSubmit &&
                  voteDetailInfo.Status === 1 &&
                  voteDetailInfo.IsRealTimeSaveResult
                "
              >
                已提交
              </span>
              <el-link
                type="primary"
                title="评委可以重新投票"
                v-if="
                  scope.row.IsSubmit &&
                  voteDetailInfo.Status === 1 &&
                  !voteDetailInfo.IsRealTimeSaveResult
                "
                @click="againVote(scope.row)"
                :key="scope.row.UserId + 'again'"
                style="margin-left: 10px"
              >
                重新投票
              </el-link>
              <i
                :title="scope.row.SaveTime"
                class="el-icon-alarm-clock"
                v-if="scope.row.IsSubmit"
              ></i>
              <span style="color: #e6a23c" v-if="!scope.row.IsSubmit">
                未提交
              </span>
              <el-link
                type="primary"
                title="全通过提交"
                v-if="
                  userRole === 1 &&
                  !scope.row.IsSubmit &&
                  voteDetailInfo.Status === 1 &&
                  voteDetailInfo.VoteType === 0
                "
                @click="submitShortlistedVote(scope.row)"
                :key="scope.row.UserId + 'submitShortlistedVote'"
                style="margin-left: 10px"
              >
                提交
              </el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          min-width="260"
          v-for="(col, index) in voteDetailInfo.Columns"
          :property="col.ColumnProp"
          :key="col.ColumnLabel + index"
        >
          <template slot="header">
            {{ col.Sort }}
            ）
            {{ col.ColumnLabel }}
          </template>
          <template slot-scope="scope">
            <span
              :style="{
                color: scope.row[scope.column.property + '_color']
              }"
            >
              {{ scope.row[scope.column.property] }}
            </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="radioView === 'user'"
        style="margin-top: 10px"
        @size-change="userHandleSizeChange"
        @current-change="userHandleCurrentChange"
        :current-page="userCurrentPage"
        :page-sizes="[10, 20, 30, 50, 100, 500, 1000, 5000]"
        :page-size="userQuery.MaxResultCount"
        :layout="pagination_layout"
        :total="userTotalCount"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import voteManageApi from '../../../../api/vote/voteManage'
export default {
  data () {
    return {
      projectTableKey: 'table' + new Date().getTime(),
      tableHeight: window.innerHeight - 300,
      radioView: 'user',
      voteDetailInfo: {
        Items: [],
        Columns: []
      },
      userTotalCount: 0,
      userQuery: {
        VoteId: null,
        KeyWord: null,
        SkipCount: 0,
        MaxResultCount: 10,
        ViewType: 'user'
      },
      userCurrentPage: 1,
      voteDetailProjectInfo: {
        Items: [],
        Columns: []
      },
      projectTotalCount: 0,
      projectQuery: {
        VoteId: null,
        KeyWord: null,
        SkipCount: 0,
        MaxResultCount: 10,
        ViewType: 'project'
      },
      projectCurrentPage: 1,
      pagination_layout: 'prev, pager, next',
      voteInfo: {
        voteName: null,
        voteStrState: 0
      },
      userRole: -1
    }
  },
  methods: {
    goBack: function () {
      this.$router.push({ name: 'meetingVote', params: { mid: this.$route.params.mid } })
    },
    getVoteDetailByUsers: function () {
      const _this = this
      const openLoading = _this.openLoading('', '.main_body')
      _this.userQuery.VoteId = _this.$route.params.vid
      voteManageApi.getVoteDetails(_this.userQuery).then(data => {
        _this.voteDetailInfo = data
        _this.voteInfo.voteName = _this.voteDetailInfo.VoteName
        _this.voteInfo.voteStrState = _this.voteDetailInfo.StrState
        _this.userTotalCount = data.TotalCount
        _this.$nextTick(() => {
          if (_this.$refs.userTable) {
            _this.$refs.userTable.doLayout()
          }
          // el-table加ref="userTable"
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    userHandleSizeChange (val) {
      this.userQuery.MaxResultCount = val
      this.getVoteDetailByUsers()
    },
    userHandleCurrentChange (val) {
      this.userCurrentPage = val
      this.userQuery.SkipCount = (val - 1) * this.userQuery.MaxResultCount
      this.getVoteDetailByUsers()
    },
    getVoteDetailByProjects: function () {
      const _this = this
      const openLoading = _this.openLoading('', '.main_body')
      _this.projectQuery.VoteId = _this.$route.params.vid
      voteManageApi.getVoteDetails(_this.projectQuery).then(data => {
        _this.voteDetailProjectInfo = data
        _this.voteInfo.voteName = _this.voteDetailProjectInfo.VoteName
        _this.voteInfo.voteStrState = _this.voteDetailProjectInfo.StrState
        _this.projectTotalCount = data.TotalCount
        _this.projectTableKey = 'table' + new Date().getTime()
        _this.$nextTick(() => {
          _this.$refs.projectTable.doLayout()
          // el-table加ref="projectTable"
        })
        openLoading.close()
      }).catch(err => {
        openLoading.close()
        return err
      })
    },
    projectHandleSizeChange (val) {
      this.projectQuery.MaxResultCount = val
      this.getVoteDetailByProjects()
    },
    projectHandleCurrentChange (val) {
      this.projectCurrentPage = val
      this.projectQuery.SkipCount = (val - 1) * this.projectQuery.MaxResultCount
      this.getVoteDetailByProjects()
    },
    search: function () {
      const _this = this
      if (_this.radioView === 'project') {
        _this.projectQuery.SkipCount = 0
        _this.getVoteDetailByProjects()
      } else {
        _this.userQuery.SkipCount = 0
        _this.getVoteDetailByUsers()
      }
    },
    refresh: function () {
      const _this = this
      if (_this.radioView === 'project') {
        this.getVoteDetailByProjects()
      } else {
        this.getVoteDetailByUsers()
      }
    },
    againVote: function (item) {
      const _this = this
      let userName = ''
      let userId = null
      if (this.radioView === 'project') {
        userName = item.ColumnLabel
        userId = item.ColumnProp
      } else {
        userName = item.UserName
        userId = item.UserId
      }
      this.$confirm('确认重新投票吗？投票人：' + userName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('', '.main_body')
        _this.userQuery.VoteId = _this.$route.params.vid
        voteManageApi.againVote({
          VoteId: _this.$route.params.vid,
          UserId: userId
        }).then(data => {
          if (data) {
            // item.IsSubmit = false
            _this.$set(item, 'IsSubmit', false)
            if (_this.radioView === 'project') {
              _this.projectTableKey = 'table' + new Date().getTime()
              _this.$nextTick(() => {
                _this.$refs.projectTable.doLayout()
                // el-table加ref="userTable"
              })
            } else {
              _this.$nextTick(() => {
                _this.$refs.userTable.doLayout()
                // el-table加ref="userTable"
              })
            }
            this.$message({
              type: 'success',
              message: userName + ' 可以重新投票',
              customClass: 'custom_message'
            })
          }
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    submitShortlistedVote: function (item) {
      const _this = this
      let userName = ''
      let userId = null
      if (this.radioView === 'project') {
        userName = item.ColumnLabel
        userId = item.ObjectId
      } else {
        userName = item.UserName
        userId = item.UserId
      }
      this.$confirm('确认提交投票吗？投票人：' + userName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('', '.main_body')
        _this.userQuery.VoteId = _this.$route.params.vid
        voteManageApi.submitShortlistedVote({
          VoteId: _this.$route.params.vid,
          UserId: userId
        }).then(data => {
          // _this.$set(item, 'IsSubmit', true)
          if (_this.radioView === 'project') {
            _this.getVoteDetailByProjects()
          } else {
            _this.getVoteDetailByUsers()
          }
          this.$message({
            type: 'success',
            message: userName + ' 已经提交投票',
            customClass: 'custom_message'
          })
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    removeVoteUser: function (item) {
      const _this = this
      let userName = ''
      let userId = null
      if (this.radioView === 'project') {
        userName = item.ColumnLabel
        userId = item.ColumnProp
      } else {
        userName = item.UserName
        userId = item.UserId
      }
      this.$confirm('确认从该投票移除投票人吗？投票人：' + userName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('', '.main_body')
        _this.userQuery.VoteId = _this.$route.params.vid
        voteManageApi.removeVoteUser({
          VoteId: _this.$route.params.vid,
          UserId: userId
        }).then(data => {
          if (data) {
            _this.$set(item, 'IsRemove', 1)
            if (_this.radioView === 'project') {
              _this.projectTableKey = 'table' + new Date().getTime()
              _this.$nextTick(() => {
                _this.$refs.projectTable.doLayout()
                // el-table加ref="userTable"
              })
            } else {
              _this.$nextTick(() => {
                _this.$refs.userTable.doLayout()
                // el-table加ref="userTable"
              })
            }
            this.$message({
              type: 'success',
              message: userName + ' 已移除',
              customClass: 'custom_message'
            })
          }
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    addVoteUser: function (item) {
      const _this = this
      let userName = ''
      let userId = null
      if (this.radioView === 'project') {
        userName = item.ColumnLabel
        userId = item.ColumnProp
      } else {
        userName = item.UserName
        userId = item.UserId
      }
      this.$confirm('确认重新添加该投票人吗？投票人：' + userName, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        customClass: 'custom_message_box'
      }).then(() => {
        const openLoading = _this.openLoading('', '.main_body')
        _this.userQuery.VoteId = _this.$route.params.vid
        voteManageApi.addVoteUser({
          VoteId: _this.$route.params.vid,
          UserId: userId
        }).then(data => {
          if (data) {
            _this.$set(item, 'IsRemove', 0)
            if (_this.radioView === 'project') {
              _this.projectTableKey = 'table' + new Date().getTime()
              _this.$nextTick(() => {
                _this.$refs.projectTable.doLayout()
                // el-table加ref="userTable"
              })
            } else {
              _this.$nextTick(() => {
                _this.$refs.userTable.doLayout()
                // el-table加ref="userTable"
              })
            }
            this.$message({
              type: 'success',
              message: userName + ' 已移除',
              customClass: 'custom_message'
            })
          }
          openLoading.close()
        }).catch(err => {
          openLoading.close()
          return err
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
          customClass: 'custom_message'
        })
      })
    },
    viewChange: function () {
      const _this = this
      if (_this.radioView === 'project') {
        _this.projectQuery.SkipCount = 0
        this.getVoteDetailByProjects()
      } else {
        _this.userQuery.SkipCount = 0
        this.getVoteDetailByUsers()
      }
    },
    exportData: function () {
      const _this = this
      _this.openLoading()
      if (_this.radioView === 'project') {
        voteManageApi.exportVoteDetailsByProjects({
          VoteId: _this.$route.params.vid
        }).then(data => {
          if (!data) {
            return
          }
          let fileName = '投票明细'
          fileName = _this.voteDetailProjectInfo.VoteName + '-投票明细'
          const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

          const elink = document.createElement('a')
          // 设置下载文件名
          elink.setAttribute('download', fileName + '.xlsx')
          elink.style.display = 'none'
          elink.href = fileUrl
          document.body.appendChild(elink)
          elink.click()

          document.body.removeChild(elink) // 下载完成移除元素
          window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
          _this.openLoading().close()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      } else {
        voteManageApi.exportVoteDetailsByUsers({
          VoteId: _this.$route.params.vid
        }).then(data => {
          if (!data) {
            return
          }
          let fileName = '投票明细'
          fileName = _this.voteDetailInfo.VoteName + '-投票明细'
          const fileUrl = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel;charset=utf-8' }))

          const elink = document.createElement('a')
          // 设置下载文件名
          elink.setAttribute('download', fileName + '.xlsx')
          elink.style.display = 'none'
          elink.href = fileUrl
          document.body.appendChild(elink)
          elink.click()

          document.body.removeChild(elink) // 下载完成移除元素
          window.URL.revokeObjectURL(fileUrl) // 释放掉blob对象
          _this.openLoading().close()
        }).catch(err => {
          _this.openLoading().close()
          return err
        })
      }
    },
    userTableCellClassName: function ({ row, column, rowIndex, columnIndex }) {
      if (row.IsRemove) {
        return 'vote_detail_table_cell_remove'
      } else {
        if (row.IsSubmit) {
          // console.log(this.voteDetailInfo.Items[rowIndex].UserName)
          return 'vote_detail_table_cell_submit'
        } else {
          return 'vote_detail_table_cell_default'
        }
      }
    },
    userTableHeaderCellClassName: function ({ row, column, rowIndex, columnIndex }) {
      return 'vote_detail_table_headCell_default'
    },
    projectTableCellClassName: function ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex > 0) {
        // console.log(this.voteDetailProjectInfo.Columns[columnIndex - 1])
        if (this.voteDetailProjectInfo.Columns[columnIndex - 1].IsRemove) {
          return 'vote_detail_table_cell_remove'
        } else {
          if (this.voteDetailProjectInfo.Columns[columnIndex - 1].IsSubmit) {
            return 'vote_detail_table_cell_submit'
          } else {
            return 'vote_detail_table_cell_default'
          }
        }
      } else {
        return 'vote_detail_table_cell_default'
      }
    },
    projectTableHeaderCellClassName: function ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex > 0) {
        if (this.voteDetailProjectInfo.Columns[columnIndex - 1].IsRemove) {
          return 'vote_detail_table_headCell_remove'
        } else {
          if (this.voteDetailProjectInfo.Columns[columnIndex - 1].IsSubmit) {
            return 'vote_detail_table_headCell_submit'
          } else {
            return 'vote_detail_table_headCell_default'
          }
        }
      } else {
        return 'vote_detail_table_headCell_default'
      }
    },
    getCurrentUserRole: function () {
      this.$api.userInfo.getCurrentUserRole().then(data => {
        this.userRole = data
      }).catch(err => {
        return err
      })
    }
  },
  created () {
    this.viewChange()
    this.getCurrentUserRole()
    if (this.is_xs) {
      this.pagination_layout = 'total,prev, pager, next'
    } else {
      this.pagination_layout = 'total, sizes, prev, pager, next, jumper'
    }
  }
}
</script>
<style lang="less">
.el-table thead.is-group th {
  background: none;
}

.el-table thead.is-group tr:first-of-type th:first-of-type {
  border-bottom: none;
}

.el-table thead.is-group tr:first-of-type th:first-of-type:before {
  content: '';
  position: absolute;
  width: 1px;
  height: 138px;
  top: 0;
  left: 0;
  background-color: grey;
  opacity: 0.3;
  display: block;
  transform: rotate(-73deg);
  transform-origin: top;
}

.el-table thead.is-group tr:last-of-type th:first-of-type:before {
  content: '';
  position: absolute;
  width: 1px;
  height: 138px;
  bottom: 0;
  right: 0;
  background-color: grey;
  opacity: 0.3;
  display: block;
  transform: rotate(-73deg);
  transform-origin: bottom;
}
.vote_detail_el_table--border {
  border-color: #909399 !important;
}
.vote_detail_table_headCell_remove {
  background-color: #fcbaba !important;
  border-color: #909399 !important;
}

.vote_detail_table_headCell_submit {
  background-color: #d9ecff !important;
  border-color: #909399 !important;
}

.vote_detail_table_headCell_default {
  background-color: #ffffff !important;
  border-color: #909399 !important;
}
.vote_detail_table_cell_remove {
  background-color: #fcbaba !important;
  border-color: #909399 !important;
}

.vote_detail_table_cell_submit {
  background-color: #d9ecff !important;
  border-color: #909399 !important;
}

.vote_detail_table_cell_default {
  background-color: #ffffff !important;
  border-color: #909399 !important;
}
</style>
